<template>
  <div class="login_container">
    <div class="ultrasonic_center">
      <div>
        <div class="titile">患者信息</div>
        <div class="titleli">患者姓名:{{userData.username}}</div>
        <div class="titleli">患者性别:{{userData.gender == 0 ? '男':'女'}}</div>
        <div class="titleli">患者年龄:{{userData.studyAge}}</div>
        <div class="titile">检查信息:</div>
        <div class="titleli">检查号:{{userData.studyNo}}</div>
        <div class="titleli">检查类型:{{userData.studyModality}}</div>
        <div class="titleli">检查部位:{{userData.partExamined}}</div>
        <div class="titleli">检查时间:{{userData.times}}</div>
      </div>
      <div>
        <button
          v-if='onfalse'
          
            type="primary"
            class="search_click"
            @click="on()"
            >开始</button
          >
          <el-button v-if='!onfalse' class="login_Edit" @click="off()">结束</el-button>
      </div>
    </div>
  </div>
</template>

<script>
// // import LangSelect from '@/components/LangSelect'
export default {
  name: "pdfconent",
  components: { },
  //   components: { SocialSign },
  data() {
    return {
      onfalse:true,
      userData:''
    };
  },
  created(e) {
    // console.log(window.location.href.split('&token=')[1])
    this.token = window.location.href.split('&token=')[1];
    // console.log(window.location.href.split('&token=')[0].split('?id=')[1])
    this.id = window.location.href.split('&token=')[0].split('?id=')[1];
    depot
        .get({
          url: "/v1/study/getStudy",
          params: {
            token: this.token,
            id: this.id,
          },
        })
        .then((res) => {
          console.log(res);
          // res.data.studyAge.replace('Y','')
         res.data.studyAge = res.data.studyAge.replace(/y/g,'')
          console.log('res.data.studyAge',res.data.studyAge.replace(/y/g,''))
          this.userData = res.data;
          
          this.userData.times = this.time(this.userData.studyDatetime)
          // this.userData.birthDays = this.timestampToTimes(this.userData.birthDay)
          // this.userData.studyAge.replace('Y','');
        })
        .catch((err) => {
          console.log(err);
        });
  },
  watch: {
    
  },
  mounted() {
    
  },
  methods:{
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
    off(){
      this.onfalse = true;
      var url = {
        patient:{
          username:this.userData.username,
        gender:this.userData.gender,
        age:this.userData.studyAge.replace('Y',''),
        birthDay:this.userData.birthday,
        },
        study:{
        studyNo:this.userData.studyNo,
        modality:this.userData.studyModality,
        partExamined:this.userData.partExamined,
        studyDateTime:this.userData.times,
        }
      }
      
        window.cefQuery({
    request: 'stopRecord:' + JSON.stringify(url),
    onSuccess: function(response) {
      alert(response);
    },
    onFailure: function(error_code, error_message) {
        alert(error_message);
    }
  });
    },
   on (){
  this.onfalse = false;
  window.cefQuery({
    request: 'startRecord',
    onSuccess: function(response) {
      alert(response);
    },
    onFailure: function(error_code, error_message) {
        alert(error_message);
    }
  });
    },
    timestampToTime(timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        var D = date.getDate() + ' ';
        var h = date.getHours() + ':';
        var m = date.getMinutes() + ':';
        var s = date.getSeconds(); 
        return Y+M+D+h+m+s;
    },
  },
 
};
</script>

<style lang="scss">
  .login_container {
    display: flex;
    justify-content: center;
  }
  .ultrasonic_center {
    width: 300px;
    height: 100vh;
    // background: #000;
  }
  .search_click {
  color:#fff;
  width: 100px;
  height: 40px;
  background: #009b43;
  border: none;

    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    border-radius: 3px;
    margin-top: 20px;
}
.search_click:hover {
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
   background-position: 100% 0;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    margin-top: 20px;
}
.login_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  background: #EEEEEE;
  border-radius: 4px;
  border: none;
  color: #999999;
    margin-top: 20px;
}
.titile {
  font-size: 24px;
  font-weight: 500;
  margin-top: 10px;
}
.titleli {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/ultrasonic/index.vue